


document.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth <= 990) return; 

    var totalLooks = 23;  // #lookの総数
    var observers = [];  

    function handleIntersection(entries, observer) {
        entries.forEach(entry => {
            var lookElement = entry.target;
            var lookId = lookElement.id;

            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                $('.l_thumbnail ul li a[href="#' + lookId + '"]').addClass("l_current");
            } else {
                $('.l_thumbnail ul li a[href="#' + lookId + '"]').removeClass("l_current");
            }
        });
    }

    var options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
    };

    for (var i = 1; i <= totalLooks; i++) {
        var lookElement = document.getElementById('look' + i);
        var observer = new IntersectionObserver(handleIntersection, options);
        observer.observe(lookElement);
        observers.push(observer);
    }
});



 
$(document).ready(function() {

    function handleIntersect(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                $('#gd_footerWrap').addClass('l-is-show');
            } else {
                $('#gd_footerWrap').removeClass('l-is-show');
            }
        });
    }

    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };

    const observer = new IntersectionObserver(handleIntersect, options);

    // #look最後の子要素
    const target = $('#look23').children().last()[0];

    if (target) {
        observer.observe(target);
    }
});





$(document).ready(function() {
    $('#l_listcontainer').on('classChanged', function() {
        if ($(this).hasClass('active')) {
            setTimeout(function() {
                $('.lookanchorspWrap').addClass('fixed');
            }, 400); 
        } else {
            $('.lookanchorspWrap').removeClass('fixed');
        }
    });

  
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            if (mutation.attributeName === 'class') {
                $(mutation.target).trigger('classChanged');
            }
        });
    });
    observer.observe(document.querySelector('#l_listcontainer'), {
        attributes: true
    });
});


   
$(function(){
$('a[href^=#]').click(function(){
 var speed = 500;
 var href= $(this).attr("href");
 var target = $(href == "#" || href == "" ? 'html' : href);
 var position = target.offset().top;
 $("html, body").animate({scrollTop:position}, speed, "swing");
 return false;
});
});
 

